// extracted by mini-css-extract-plugin
export default {"couponsParent":"Coupons_couponsParent__cPctk"};